const badWords = [
  "fuck",
  "shit",
  "bitch",
  "bastard",
  "asshole",
  "dick",
  "pussy",
  "cock",
  "crap",
  "damn",
  "motherfucker",
  "fucker",
  "bullshit",
  "cunt",
  "twat",
  "prick",
  "jerk",
  "idiot",
  "moron",
  "retard",
  "dumbass",
  "jackass",
  "whore",
  "slut",
  "sex",
  "porn",
  "nsfw",
  "nude",
  "naked",
  "boobs",
  "tits",
  "milf",
  "fetish",
  "hardcore",
  "xxx",
  "anal",
  "blowjob",
  "cum",
  "dildo",
  "fisting",
  "nigga",
  "nigger",
  "niggah",
  "rape",
];

export default badWords;
